/* Types */
import { Promocode } from '@/types/api/api-v3/orders/order'

export interface EcommerceProduct {
  id: string
  name: string
  brand: string
  price: number
  category?: string
  variant?: string
  category_name?: string
  quantity?: number
}

export enum EcommerceEventName {
  ADD = 'add',
  PURCHASE = 'purchase',
  REMOVE = 'remove',
  DETAIL = 'detail',
}

interface EcommerceAction {
  id: number
  coupon?: Promocode
  revenue?: number
}

interface EcommerceCurrency {
  currencyCode?: string
}

type EcommerceData = {
  [key in EcommerceEventName]: {
    actionField: EcommerceAction
    products: EcommerceProduct[]
  }
}

export interface Ecommerce {
  ecommerce: EcommerceCurrency | EcommerceData
}
